export enum FileType {
  GROUP = 'GROUP',
  RATE = 'RATE',
}
